import React, {useEffect, useState} from 'react';
import './index.scss'
import classNames from 'classnames';

interface Props {
  items: any;
  ativo: any;
  minWidth?: any;
  onClick: any;
}

export default function Tabs(props: Props) {


  const items = props.items;

  const itemTemplate = (item: any) => {
    const isActive = item.id === props.ativo;
    return (
      <>
        <div
          onClick={() => {
            window.history.replaceState(null, '', '?tab=' + item.id);
            props.onClick(item.id)
          }}
          className={`participa-tab-item ${classNames({'active': isActive})}`}>
          <i className={item.icon}/>
          <label>{item.name}</label>
        </div>

      </>
    );
  }
  return (
    <>
      <div className="participa-tabs-wrapper">
        <div style={{width: '100%', display: 'flex'}}>
          {items.map((m: any) => <div key={m.id}>{itemTemplate(m)}</div>)}
        </div>
      </div>
      <div style={{borderBottom: '2px solid #92929a', marginTop: '-2px'}}></div>
    </>
  );
}
